/**
 * ?odul=gordonix15 parametresiyle özel ödül modalı
 */
(function () {
  var PARAM = "odul";
  var VALUE = "gordonix15";
  var root = document.getElementById("gx-odul-root");
  if (!root) return;

  var params = new URLSearchParams(window.location.search);
  if (params.get(PARAM) !== VALUE) return;

  var CODE = root.getAttribute("data-code") || "GORDONIX15";
  var videoSrc = root.getAttribute("data-video") || "";

  var overlay = document.createElement("div");
  overlay.className = "gx-odul-overlay";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "gx-odul-title");
  overlay.innerHTML =
    '<div class="gx-odul-modal">' +
    '<button type="button" class="gx-odul-close" aria-label="Kapat">&times;</button>' +
    '<p class="gx-odul-kicker">Gordonix</p>' +
    '<h2 class="gx-odul-title" id="gx-odul-title">Tebrikler!</h2>' +
    '<p class="gx-odul-text">Size özel bir indirim kodu kazandınız. Bu kod yalnızca resmi web sitemizde geçerlidir.</p>' +
    '<div class="gx-odul-media"><video playsinline preload="metadata"></video></div>' +
    '<button type="button" class="gx-odul-reveal">Kodu görüntüle</button>' +
    '<button type="button" class="gx-odul-code" aria-label="İndirim kodunu kopyala"></button>' +
    '<p class="gx-odul-code-hint"></p>' +
    "</div>";

  document.body.appendChild(overlay);
  document.body.classList.add("gx-odul-lock");

  // Konfeti: body üzerinde, her şeyin üstünde (video katmanının altında kalmasın)
  var canvas = document.createElement("canvas");
  canvas.className = "gx-odul-canvas";
  canvas.setAttribute("aria-hidden", "true");
  document.body.appendChild(canvas);

  var modal = overlay.querySelector(".gx-odul-modal");
  var closeBtn = overlay.querySelector(".gx-odul-close");
  var revealBtn = overlay.querySelector(".gx-odul-reveal");
  var codeBtn = overlay.querySelector(".gx-odul-code");
  var hint = overlay.querySelector(".gx-odul-code-hint");
  var mediaBox = overlay.querySelector(".gx-odul-media");
  var video = overlay.querySelector("video");
  if (videoSrc) video.src = videoSrc;
  codeBtn.textContent = CODE;

  var confettiPieces = [];
  var confettiRaf = 0;
  var confettiCtx = canvas.getContext("2d");
  /** full | edge | soft */
  var confettiMode = "full";
  var COLORS = ["#7a1f1f", "#c45c26", "#e8b86d", "#1c1412", "#f5e6d3", "#d4a017"];

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }

  function videoAvoidRect() {
    if (!mediaBox.classList.contains("is-visible")) return null;
    var r = mediaBox.getBoundingClientRect();
    if (r.width < 20 || r.height < 20) return null;
    var pad = 18;
    return {
      left: r.left - pad,
      top: r.top - pad,
      right: r.right + pad,
      bottom: r.bottom + pad,
    };
  }

  function makePiece(x, y, vx, vy) {
    return {
      x: x,
      y: y,
      w: 6 + Math.random() * 7,
      h: 8 + Math.random() * 10,
      vx: vx,
      vy: vy,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.22,
      color: COLORS[(Math.random() * COLORS.length) | 0],
    };
  }

  function spawnConfetti(kind) {
    var w = canvas.width;
    var h = canvas.height;
    var avoid = videoAvoidRect();
    var i;

    if (kind === "burst-full") {
      for (i = 0; i < 110; i++) {
        confettiPieces.push(
          makePiece(
            Math.random() * w,
            Math.random() * h * 0.4 - 50,
            (Math.random() - 0.5) * 7,
            2 + Math.random() * 5
          )
        );
      }
      return;
    }

    if (kind === "burst-end") {
      for (i = 0; i < 140; i++) {
        confettiPieces.push(
          makePiece(
            Math.random() * w,
            -30 - Math.random() * 80,
            (Math.random() - 0.5) * 8,
            2.5 + Math.random() * 6
          )
        );
      }
      return;
    }

    if (kind === "edge") {
      // Ekranın sol/sağ %22’si — mobil tam geniş video olsa bile şeritler ekran içinde kalır
      var band = Math.max(52, Math.min(96, w * 0.22));
      var count = 24;
      for (i = 0; i < count; i++) {
        var leftSide = i % 2 === 0; // eşit sol/sağ
        var x = leftSide
          ? 4 + Math.random() * (band - 4)
          : w - band + Math.random() * (band - 4);
        confettiPieces.push(
          makePiece(
            x,
            -20 - Math.random() * 50,
            leftSide ? -0.2 - Math.random() * 0.8 : 0.2 + Math.random() * 0.8,
            1.8 + Math.random() * 3.2
          )
        );
      }
      return;
    }

    if (kind === "sparse") {
      // Tek tük, ekranın önünden geçsin
      var n = 2 + ((Math.random() * 2) | 0);
      for (i = 0; i < n; i++) {
        confettiPieces.push(
          makePiece(
            Math.random() * w,
            -20 - Math.random() * 40,
            (Math.random() - 0.5) * 3,
            1.4 + Math.random() * 2.5
          )
        );
      }
    }
  }

  function steerAwayFromVideo(p, avoid) {
    if (!avoid) return;
    // Sadece video ortasının iç kısmından uzaklaştır; kenar şeritlere dokunma
    var inset = Math.min(72, (avoid.right - avoid.left) * 0.18);
    var left = avoid.left + inset;
    var right = avoid.right - inset;
    if (p.x > left && p.x < right && p.y > avoid.top && p.y < avoid.bottom) {
      var mid = (left + right) / 2;
      var dir = p.x < mid ? -1 : 1;
      var nextX = p.x + dir * 12;
      // Ekran dışına itme
      nextX = Math.max(8, Math.min(canvas.width - 8, nextX));
      p.x = nextX;
      p.vx = dir * (1.2 + Math.random() * 0.8);
    }
  }

  function tickConfetti() {
    confettiCtx.clearRect(0, 0, canvas.width, canvas.height);
    var avoid = confettiMode === "edge" ? videoAvoidRect() : null;
    for (var i = confettiPieces.length - 1; i >= 0; i--) {
      var p = confettiPieces[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.045;
      p.rot += p.vr;
      if (confettiMode === "edge") steerAwayFromVideo(p, avoid);
      confettiCtx.save();
      confettiCtx.translate(p.x, p.y);
      confettiCtx.rotate(p.rot);
      confettiCtx.fillStyle = p.color;
      confettiCtx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      confettiCtx.restore();
      if (p.y > canvas.height + 50 || p.x < -80 || p.x > canvas.width + 80) {
        confettiPieces.splice(i, 1);
      }
    }
    if (overlay.classList.contains("is-open")) {
      confettiRaf = requestAnimationFrame(tickConfetti);
    }
  }

  function startDrip(fn, intervalMs) {
    if (overlay._drip) clearInterval(overlay._drip);
    overlay._drip = setInterval(function () {
      if (!overlay.classList.contains("is-open")) {
        clearInterval(overlay._drip);
        return;
      }
      fn();
    }, intervalMs);
  }

  function openModal() {
    resizeCanvas();
    overlay.classList.add("is-open");
    confettiMode = "full";
    // Tek açılış patlaması; sonra seyrek hafif dökülme (üst üste yoğun burst yok)
    spawnConfetti("burst-full");
    cancelAnimationFrame(confettiRaf);
    confettiRaf = requestAnimationFrame(tickConfetti);
    startDrip(function () {
      if (confettiPieces.length > 55) return;
      spawnConfetti("sparse");
      spawnConfetti("sparse");
    }, 1400);
  }

  function closeModal() {
    overlay.classList.remove("is-open");
    document.body.classList.remove("gx-odul-lock");
    video.pause();
    cancelAnimationFrame(confettiRaf);
    if (overlay._drip) clearInterval(overlay._drip);
    confettiCtx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.remove();
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(PARAM);
      var next = url.pathname + (url.search || "") + url.hash;
      window.history.replaceState({}, "", next || "/");
    } catch (e) {
      /* yok */
    }
    setTimeout(function () {
      overlay.remove();
    }, 380);
  }

  function revealVideo() {
    revealBtn.remove();
    modal.classList.add("has-video");
    mediaBox.classList.add("is-visible");
    confettiMode = "edge";
    // Ortadakileri temizle, kenarlardan bolca dök
    requestAnimationFrame(function () {
      var avoid = videoAvoidRect();
      if (avoid) {
        confettiPieces = confettiPieces.filter(function (p) {
          return p.x < avoid.left || p.x > avoid.right;
        });
      }
      spawnConfetti("edge");
      spawnConfetti("edge");
      startDrip(function () {
        spawnConfetti("edge");
      }, 700);
    });
    video.play().catch(function () {
      /* etkileşim sonrası genelde çalışır */
    });
  }

  function showCode() {
    codeBtn.classList.add("is-visible");
    hint.textContent = "Kutuya tıkla, kodu kopyala";
    hint.classList.add("is-visible");
    // Yoğun bitiş patlaması
    confettiMode = "full";
    spawnConfetti("burst-end");
    spawnConfetti("burst-end");
    // Ardından tek tük ön planda
    setTimeout(function () {
      if (!overlay.classList.contains("is-open")) return;
      confettiMode = "soft";
      startDrip(function () {
        spawnConfetti("sparse");
      }, 2200);
    }, 1800);
  }

  function copyCode() {
    var done = function () {
      codeBtn.classList.add("is-done");
      hint.textContent = "Kopyalandı!";
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(CODE).then(done).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
    function fallbackCopy() {
      var ta = document.createElement("textarea");
      ta.value = CODE;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch (e) {
        /* yok */
      }
      ta.remove();
      done();
    }
  }

  closeBtn.addEventListener("click", closeModal);
  revealBtn.addEventListener("click", revealVideo);
  codeBtn.addEventListener("click", copyCode);
  video.addEventListener("ended", showCode);
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeModal();
  });
  window.addEventListener("resize", resizeCanvas);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) closeModal();
  });

  requestAnimationFrame(function () {
    openModal();
  });
})();
